var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleUpLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 256C16 388.58 123.42 496 256 496S496 388.58 496 256C496 123.418 388.58 16 256 16S16 123.418 16 256ZM338.665 159.369C341.151 165.347 339.77 172.23 335.196 176.804L289.941 222.059L357.823 289.941C370.32 302.438 370.32 322.699 357.823 335.196L335.196 357.823C322.699 370.32 302.438 370.32 289.941 357.823L222.059 289.941L176.804 335.196C172.23 339.77 165.347 341.151 159.369 338.665C153.381 336.19 149.492 330.357 149.492 323.882V165.49C149.492 156.655 156.655 149.492 165.49 149.492H323.882C330.357 149.492 336.19 153.381 338.665 159.369Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUpLeft);
export default __webpack_public_path__ + "static/media/circle-up-left.645102be47bb937cc08ca15dce02702c.svg";
export { ForwardRef as ReactComponent };